
// npm install nspell dictionary-en

import { getlocalhostDatas } from './apis';
import NSpell from 'nspell';

let worker = null;
let initPromise = null;

// nspell
let spell = null;
let loadingPromise = null;
// https://datasotto.myotto.fr/dict-en/index.aff

/*
async function loadDictionary() {
  
  const aff = await fetch(getlocalhostDatas() + '/dict-en/index.aff').then(r => r.text());
  const dic = await fetch(getlocalhostDatas() + '/dict-en/index.dic').then(r => r.text());

  console.log(dic)
  return new NSpell(aff, dic);
}    
*/

export async function initSpellchecker() {
  if (spell) return spell;
  if (loadingPromise) return loadingPromise;

  loadingPromise = (async () => {
    const aff = await fetch(getlocalhostDatas() + 'dict-en/index.aff').then(r => r.text());
    const dic = await fetch(getlocalhostDatas() + 'dict-en/index.dic').then(r => r.text());
    spell = new NSpell(aff, dic);
    return spell;
  })();

  return loadingPromise;
}


export function nspellCheckWord(word) {
  if (!spell) return { ready: false };

  const correct = spell.correct(word);
  const suggestions = correct ? [] : spell.suggest(word);

  return {
    ready: true,
    correct,
    suggestions
  };
}



export async function initGrammalecte()
{
    await initGrammalecte2();
}

function initGrammalecte2() {
  if (initPromise) return initPromise;

  worker = new Worker("/grammalecte/gce_worker.js");

  initPromise = new Promise((resolve) => {
    worker.onmessage = (e) => {
      if (e.data.sActionDone === "init") {
        resolve();
      }
    };

    worker.postMessage({
      sCommand: "init",
      oParam: {
        sExtensionPath: "/grammalecte/", // chemin vers les fichiers
        dOptions: {},
        sLang: "fr",
        sContext: "JavaScript"
      },
      oInfo: {}
    });
  });

  return initPromise;
}

// grammalecteClient.js
export async function checkTextWithSuggestions(text) {
  await initGrammalecte2();

  return new Promise((resolve, reject) => {
    const results = [];
    const suggestionQueue = []; // tableau des erreurs à suggérer
    const suggestionMap = {};   // stocke les suggestions par mot

     const timeout = setTimeout(() => {
      worker.removeEventListener('message', handleMessage);
      reject(
        new Error('Timeout lors de la vérification avec Grammalecte (10s)')
      );
    }, 10000); // timeout de 10 secondes

    function handleMessage(e) {
      const data = e.data;

      // réception des erreurs de grammaire et d'orthographe
      if (data.sActionDone === "parseAndSpellcheck" && data.result) {
        const para = data.result;
        para.aSpellErrWithSuggestions = [];

        // ajouter chaque faute à la queue des suggestions
        para.aSpellErr.forEach(err => {
          if (err.sValue && !suggestionMap[err.sValue]) {
            suggestionQueue.push(err);
          }
        });

        results.push(para);
      }

      // vérifie si tous les paragraphes ont été envoyés
      if (data.bEnd && data.sActionDone === "parseAndSpellcheck") {
        if (suggestionQueue.length === 0) {
          clearTimeout(timeout);
          worker.removeEventListener("message", handleMessage);
          resolve(results);
          return;
        }

        // envoyer toutes les demandes de suggestions
        suggestionQueue.forEach(err => {
          worker.postMessage({
            sCommand: "getSpellSuggestions",
            oParam: { sWord: err.sValue },
            oInfo: {}
          });
        });
      }

      // réception des suggestions
      if (data.sActionDone === "getSpellSuggestions" && data.result) {
        const word = data.result.sWord;
        const suggestions = data.result.aSugg || [];
        suggestionMap[word] = suggestions;

        
        // vérifie si toutes les suggestions sont reçues
        if (Object.keys(suggestionMap).length === suggestionQueue.length) {
          // associe les suggestions aux erreurs dans chaque paragraphe
          results.forEach(para => {
            para.aSpellErrWithSuggestions = para.aSpellErr.map(err => ({
              ...err,  // conserve nStart, nEnd, sType, etc.
              suggestions: suggestionMap[err.sValue] || []
            }));
          });

          clearTimeout(timeout);
          worker.removeEventListener("message", handleMessage);
          resolve(results);
        }
      }
    }

    worker.addEventListener("message", handleMessage);

    worker.postMessage({
      sCommand: "parseAndSpellcheck",
      oParam: {
        sText: text,
        sCountry: "fr",
        bDebug: false,
        bContext: true
      },
      oInfo: {}
    });
  });
}
